import { useTranslation } from "next-i18next";
import Head from "next/head";

import { GetStaticProps } from "next";

import getTranslations from "../../lib/getTranslations";
import { CANONICAL_HOST, PRO_BUYER_PROGRAM_ENABLED } from "@/config";
import { ProBuyerApplicationPage } from "@/features/pro-buyer-application/components/ProBuyerApplicationPage";
import { PRO_BUYER_ROUTE } from "@/features/pro-buyer-application/static/pro-buyer-application.static";

/**
 * WHO-5688. `/pro-buyer`: the buyer-side landing page and the Pro Buyer
 * application. 404 while the program flag is off. Copy in the
 * `pro-buyer-application` Lokalise namespace.
 */
const ProBuyerRoute = () => {
  const { t } = useTranslation();
  const url = `${CANONICAL_HOST}${PRO_BUYER_ROUTE}`;
  const title = t(
    "pro-buyer-application:buyers-meta-title",
    "Pro Buyer: korting voor interieurprofessionals | Whoppah"
  );
  const description = t(
    "pro-buyer-application:buyers-meta-description",
    "Interieurontwerper, architect, stylist, stager of in hospitality? Vraag Pro Buyer aan en koop design en vintage voor je projecten met korting."
  );

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <link rel="canonical" href={url} />
      </Head>
      <ProBuyerApplicationPage />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  if (!PRO_BUYER_PROGRAM_ENABLED) {
    return { notFound: true };
  }

  return {
    props: {
      ...(await getTranslations(locale, ["pro-buyer-application"])),
    },
  };
};

export default ProBuyerRoute;
